<template>
	<div class="task-detail pb-3" @click="close_selection += 1">
		<div class="task-top-line"></div>
		<div class="task-budget mx-6 my-2">
			<div class="task-top-text">Task</div>
			<div class="task-budget">
				<FindTimesheet v-if="!isFromOmins" class="link-icon mr-3" style="height: 22px; width: 22px" :color="`rgba(25, 42, 62, 0.7)`" @click="onFindTimesheet()"/>
				<Copy v-if="otherEditPrivilege" class="link-icon" style="height: 16px; width: 16px" :color="`rgba(25, 42, 62, 0.7)`" @click="onCopyTask()"/>
				<SubTask v-if="otherEditPrivilege && !isCompleted" class="ml-3 link-icon" width="20" height="20" :color="`rgba(25, 42, 62, 0.7)`" @click="onSubTask()"/>
				<Share class="mx-3 link-icon" width="18" height="18" :color="`rgba(25, 42, 62, 0.7)`" @click="onLink()"/>
				<Delete v-if="otherEditPrivilege" class="mt-1 link-icon" style="height: 20px; width: 20px" :color="`rgba(25, 42, 62, 0.7)`" @click="onDeleteTask()"/>
				<v-icon @click="$emit('task-close')">mdi-close</v-icon>
			</div>
		</div>
		<v-alert class="mx-6 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<ProgressLinear v-if="loading"/>
		<div v-if="!loading" class="task-title" :class="$vuetify.breakpoint.xsOnly ? 'px-4':'px-6'">
			<div class="task-title-content">
				<div v-if="!isRename" class="task-title-text" :class="descPrivilege ? '':'edit-disable'">
					{{ task_name }}
					<v-btn v-if="descPrivilege" icon @click="isRename = true">
						<v-icon small>mdi-pencil-outline</v-icon>
					</v-btn>
				</div>
				<v-text-field
					v-if="isRename"
					v-model="task_name"
					:color="color"
					outlined
					hide-details
					dense
					background-color="#FFFFFF"
					clearable
					@change="onNameChange()"
				>
				</v-text-field>
				<div class="task-title my-1" style="align-items: flex-start">
					<span class="icon-text">Job</span>
					<span class="code-text ml-2">{{ task_local && task_local.job && task_local.job.code }}</span>
					<span>&nbsp;&nbsp;-&nbsp;</span>
					<span class="code-text">{{ task_local && task_local.job && task_local.job.name }}</span>
				</div>
				<div class="task-title my-1" style="align-items: flex-start">
					<span class="icon-text">Phase</span>
					<span class="code-text ml-2">{{ task_local && task_local.phase.name }}</span>
				</div>
			</div>
		</div>
		<BudgetUsed v-if="!loading" :used="budget_used"/>
		<div v-if="!loading" class="task-budget my-2" :class="$vuetify.breakpoint.xsOnly ? 'px-4':'px-6'">
			<div class="task-logged-text">Logged: {{ actual }}</div>
			<div v-if="task_local && task_local.budget !== 0" class="task-logged-text">Budget: {{ budget }}</div>
			<div v-else class="task-logged-text">No Budget</div>
		</div>
		<div v-if="!loading" class="mt-4" :class="$vuetify.breakpoint.xsOnly ? 'px-4':'px-6'">
			<v-row>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6">
					<v-btn class="text-capitalize white--text"
						:color="color"
						block 
						depressed
						:disabled="disableAutotimer(task, task_local)"
						@click="task_id = task_local.id"
					>
						Enter Time
					</v-btn>
					<div v-if="disableAutotimer(task, task_local)" class="optional-text-red">Time cannot be added to a Complete/Cancelled Job</div>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6">
					<v-btn
						v-if="!isRecording"
						class="text-capitalize white--text"
						:color="color"
						block 
						depressed
						:disabled="disableAutotimer(task, task_local)"
						@click="onAutotimer()"
					>
						Use Timer
					</v-btn>
					<div v-if="disableAutotimer(task, task_local)" class="optional-text-red">Time cannot be added to a Complete/Cancelled Job</div>
					<v-btn
						v-if="isRecording"
						class="text-capitalize white--text"
						color="#F45252"
						block 
						depressed
						@mouseover="isHover = true"
						@mouseout="isHover = false"
						@click="onAutotimer()"
					>
						<span v-if="!isHover">Stop Timer</span>
						<span v-else>{{ time_text }}</span>
					</v-btn>
				</v-col>
			</v-row>
			<v-row>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" :class="$vuetify.breakpoint.xsOnly ? '':'pb-0'">
					<div :class="!otherEditPrivilege ? 'task-info-text-disable':'task-info-text'">Kind</div>
					<KindTreeSelection
						:isKindIcon="true"
						:color="color"
						:kindParams="kindParams"
						:kindSelected="kind_selected"
						:bgColor="'#FAFAFA'"
						:closeSelection="close_selection"
						:disabled="!otherEditPrivilege"
						@kind-selected="onKindChange($event)"
					/>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:3">
					<div :class="budget_type === 0 || budget_type === 1 || !otherEditPrivilege ? 'task-info-text-disable':'task-info-text'">Task hours</div>
					<v-text-field
						key="task_hours"
						v-model="budget_enter"
						:color="color"
						:disabled="budget_type === 0 || budget_type === 1 || !otherEditPrivilege"
						:rules="rules"
						background-color="#FAFAFA"
						outlined
						dense
						hide-details
						@change="onBudget()"
					></v-text-field>
				</v-col>
				<v-col v-if="showBudget" :cols="$vuetify.breakpoint.xsOnly ? 12:3">
					<div :class="budget_type === 0 || !otherEditPrivilege ? 'task-info-text-disable':'task-info-text'">Task budget</div>
					<v-text-field
						key="task_budget"
						v-model="amount"
						:color="color"
						:prefix="currency && currency.symbol"
						:disabled="budget_type === 0 || !otherEditPrivilege"
						background-color="#FAFAFA"
						outlined
						dense
						hide-details
						type="number"
						min="0"
						oninput="if(this.value < 0) this.value = 0;"
						@change="onAmountChange($event)"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" >
					<div class="task-budget">
						<div :class="!otherEditPrivilege ? 'task-info-text-disable':'task-info-text'">Task Status</div>
					</div>
					<v-select
						v-model="task_status"
						:color="color"
						:items="getStatuses()"
						item-text="desc"
						item-value="id"
						item-color="success"
						item-disabled="disable"
						background-color="#FAFAFA"
						outlined
						dense
						hide-details
						return-object
						:disabled="!otherEditPrivilege"
						@change="onStatusChange($event)"
					>
						<template v-slot:selection="{ item }">
							<v-badge
								:color="item.color"
								left
								inline
							>
								<span class="ml-1">{{ item.desc }}</span>
							</v-badge>
						</template>
						<template v-slot:item="{item, on}">
							<v-list-item v-on="on" dense>
								<v-badge
									:color="item.color"
									left
									inline
								>
									<span class="ml-1">{{ item.desc }}</span>
								</v-badge>					
							</v-list-item>
						</template>
					</v-select>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:3">
					<div class="task-budget">
						<div :class="!otherEditPrivilege ? 'task-info-text-disable':'task-info-text'">Priority</div>
					</div>
					<v-select
						v-model="priority"
						:items="priority_levels"
						:color="color"
						item-color="success"
						outlined
						dense
						hide-details
						background-color="#FAFAFA"
						:disabled="!otherEditPrivilege"
						@change="onPriorityChange($event)"
					>
						<template v-slot:prepend-inner>   
							<v-icon color="rgba(25, 42, 62, 0.5)">mdi-star-half-full</v-icon>   
						</template>
					</v-select>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:3">
					<div class="task-budget">
						<div :class="!otherEditPrivilege ? 'task-info-text-disable':'task-info-text'">Mark as</div>
					</div>
					<v-btn-toggle v-model="ac_oc" borderless @change="onAcOcChange($event)">
						<v-btn
							class="mr-2 rounded"
							:color="ac_oc == ac_type ? 'rgba(129, 204, 0, 0.25)':''"
							:value="ac_type"
							depressed
							min-width="44" 
							max-width="44" 
							min-height="40" 
							max-height="40" 
						>
							AC
						</v-btn>
						<v-btn
							class="rounded"
							:color="ac_oc == oc_type ? 'rgba(129, 204, 0, 0.25)':''"
							:value="oc_type"
							depressed 
							min-width="44" 
							max-width="44" 
							min-height="40" 
							max-height="40" 
						>
							OC
						</v-btn>
					</v-btn-toggle>
				</v-col>
			</v-row>
			<v-row :class="$vuetify.breakpoint.xsOnly ? 'my-2':''">
				<v-col cols="12">
					<div :class="!assignPrivilege ? 'task-info-text-disable':'task-info-text'">Assigned to</div>
					<AssignedTreeSelection
						:color="color"
						:selected="assigned"
						:closeSelection="close_selection"
						:disabled="!assignPrivilege"
						:bgColor="`#FAFAFA`"
						:kinds="[task_kind]"
						@assign-selected="onAssignChange($event)"
					/>
				</v-col>
			</v-row>
			<v-row align="start" :class="$vuetify.breakpoint.xsOnly ? 'mt-0 mb-1 pt-0':'mt-2 mb-1'">
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:2" :class="$vuetify.breakpoint.xsOnly ? 'pt-0':''">
					<div class="mt-1" :class="!dateTimePrivilege ? 'task-info-text-disable':'task-info-text'">Days</div>
					<v-text-field
						v-if="days === 0"
						:color="color"
						:disabled="!dateTimePrivilege"
						background-color="#FAFAFA"
						outlined
						dense
						hide-details
					></v-text-field>
					<v-text-field
						v-if="days !== 0"
						v-model="days"
						:color="color"
						:disabled="!dateTimePrivilege"
						type="number"
						class="text-right"
						background-color="#FAFAFA"
						outlined
						dense
						min="0"
						hide-details
						oninput="if(this.value <= 0) this.value = 1;"
						@change="days = Number.parseInt($event)"
					></v-text-field>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:8" :class="$vuetify.breakpoint.xsOnly ? 'py-0':'mt-1'">
					<DateMulti
						v-if="date_start_init !== null"
						:lableText="'Start date to End date'"
						:suggestionText="`eg, 120322-130322 or 12/3/2022-13/3/2022`"
						:isSuggestion="isSuggestedEnd"
						:color="color"
						:background="`#FAFAFA`"
						:disabled="budget_type === 3 || !dateTimePrivilege"
						:dateStartInit="date_start_init"
						:dateEndInit="date_end_init"
						:validRange="date_range"
						:workdays="workdays_keys"
						:days="Number.parseInt(days)"
						@dateRange="onDateChange($event)"
					/>
					<div v-if="isSuggestedEnd" class="optional-text" style="position: relative;top: -16px;">suggested date</div>
				</v-col>
				<v-col :cols="$vuetify.breakpoint.xsOnly ? 6:2" align-self="center">
					<v-checkbox
						v-model="isAllday"
						:color="color"
						:disabled="!dateTimePrivilege"
						label="All day"
						dense
						hide-details
						@change="onAlldayChange($event)"
					></v-checkbox>
				</v-col>
			</v-row>
			<v-row v-if="!isAllday" class="mt-0">
				<DateTime
					:color="color"
					:duration="budget_enter"
					:colsNumber="3"
					:startTimeInit="time_start_init"
					:endTimeInit="time_end_init"
					:startError="start_time_error"
					:endError="end_time_error"
					:disabled="budget_type === 3 || !dateTimePrivilege"
					@time_start="onTimeStartChange($event)"
					@time_end="onTimeEndChange($event)"
				/>
			</v-row>
			<v-row class="mb-0">
				<v-col class="pt-0" :cols="$vuetify.breakpoint.xsOnly ? 12:10" :align-self="`center`">
					<v-btn v-if="!is_daysApply && dateTimePrivilege" class="text-capitalize px-1" color="#82899B" text @click="is_daysApply = true">Apply to selected days</v-btn>
					<template v-if="is_daysApply || !dateTimePrivilege">
						<div class="task-title">
							<div class="task-info-text">Apply Task budget on these days</div>
							<v-tooltip top>
								<template v-slot:activator="{ on, attrs }">
									<v-icon class="ml-2" color="#B9C2CB" small v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
								</template>
								<span>Use this to override the default work days this Task is applied to. Task budget will be divided accordingly. </span>
							</v-tooltip>
						</div>
						<v-avatar
							class="white--text mr-2"
							v-for="workday in workdays"
							:key="workday.key"
							:color="workday.isWork ? '#82899B':'rgba(25, 42, 62, 0.15)'"
							size="36"
							@click="onWorkday(workday)"
						>
							<span>{{ workday.text }}</span>
						</v-avatar>
					</template>
				</v-col>
			</v-row>
		</div>
		<TaskLinkDialog 
			v-if="link_visible" 
			:visible="link_visible" 
			:linkUrl="link_url" 
			:color="color" 
			@close="link_visible = false"
			@copy-link="onCopyLink($event)"
		/>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
		/>
		<LogTimesheet v-if="task_id !== 0" :visible="task_id !== 0" :taskId="task_id" @close="onCloseTimesheet()"/>
		<LogTimesheet
			v-if="auto_time !== 0"
			:visible="auto_time !== 0"
			:taskId="recordingTaskId"
			:autoDuration="auto_time"
			@close="auto_time = 0"
		/>
		<DeleteConfirmDialog 
			v-if="delete_visible"
			:visible="delete_visible" 
			:color="'error'"
			:title="`You are about to delete this Task.`" 
			:content="`This action cannot be undone. Are you sure?`"
			:ok="'Yes, delete'"
			:icon_name_title="'mdi-alert-circle'"
			:icon_name_front="'mdi-delete-outline'"
			:maxWidth="500"
			@cancel="delete_visible = false"
			@ok="onDelete($event)"
		/>
	</div>
</template>
<script>
import Share from "@/components/icons/share.vue";
import Copy from '@/components/icons/copy';
import SubTask from '@/components/icons/sub_task';
import Delete from '@/components/icons/delete_outline';
import FindTimesheet from "@/components/icons/find_timesheet";
import BudgetUsed from "@/components/tasks/budget_used";
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import TaskLinkDialog from "@/views/tasks/task_link_dialog";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import KindTreeSelection from "@/components/kinds/kind_tree_selection.vue";
import AssignedTreeSelection from "@/components/jobs/assigned_tree_selection.vue";
import DateMulti from "@/components/date/date_multi.vue";
import DateTime from "@/components/date/date_time.vue";
import LogTimesheet from "@/components/tasks/task_timesheet";
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";

import { validTime } from "@/common/validTime.js";
import { validHour } from "@/common/validHour.js";
import { budgetToMinutes, minutesToBudget } from "@/common/budgetToMinute.js";
import moment from 'moment';
import config from "@/config.js";
import { durationMixin } from "@/mixins/misc/durationMixin";
import { metaMixin } from "@/mixins/tasks/metaMixin";

const ALLEMPLOYEES = 2;
const ROLES = 1;
const DEPARTMENTS = 0;
const FREELANCER = 4;

const NUMERICAL_REG = config.numerical_reg;

const TEXT_COLOR = config.text_color.default;
const Error_Flag = 'Traffic;';

const ACTIVE_STATUS = 2; // according to meta, status=2 => 'Active'
const Completed_Phase = 1;
const TPc = 'TPc';
const TSr = 'TSr';

/** If selected the user will be able to enter and amend Items Charges */
const CH = 'CH';
/** the user will be able to create and amend tasks */
const TR = 'TR';
/** the user will be able to change the scheduled dates within the traffic system */
const TrSc = 'TrSc';
/** If selected the user will be able to set and amend task description */
const TrN = 'TrN';
/** If selected the user will be able to assign tasks to employees */
const TrA = 'TrA';
/** If selected the user will be able to change the scheduled dates of a subtask beyond the dates of the containing task */
const TrScO = 'TrScO';
/** If selected, entering costs or purchase orders against dead, cancelled or complete jobs will not be allowed */
const JOr = 'JOr';


const Workdays = [
	{ 
		key: 'Monday',
		text: 'M',
		isWork: true
	},
	{ 
		key: 'Tuesday',
		text: 'T',
		isWork: true
	},
	{ 
		key: 'Wednesday',
		text: 'W',
		isWork: true
	},
	{ 
		key: 'Thursday',
		text: 'T',
		isWork: true
	},
	{ 
		key: 'Friday',
		text: 'F',
		isWork: true
	},
	{ 
		key: 'Saturday',
		text: 'S',
		isWork: false
	},
	{ 
		key: 'Sunday',
		text: 'S',
		isWork: false
	}
];

const Any_Mode = 1;
const Overhead_Mode = 2;

/** 0-'',1-AC,2-OC */
const AC_Type = 1;
const OC_Type = 2;

/** some old task, the workday is empty, set the default value */
const Default_Workday = '1111100';

export default {
	name: 'TaskDetail',
	mixins: [ durationMixin, metaMixin ],
	props: {
		color: {
			type: String,
			default: ''
		},
		task: {
			type: Object,
			default: () => {}
		},
		isDuplication: {
			type: Boolean,
			default: false
		},
	},
	data() {
		this.ac_type = AC_Type;
		this.oc_type = OC_Type;

		return {
			loading: false,
			error_msg: '',
			task_local: null,
			priority_levels: [1, 2, 3, 4, 5],

			task_name: '',
			task_phase: null,
			task_status: null,
			task_kind: null,
			task_job: null,
			phaseItems: [],

			priority: 0,
			ac_oc: null,

			amount: 0,
			unit: '0',
			unit_type: null,
			budget_enter: '',
			budget_type: 0,

			charge_rate_total: 0,

			currency: { id: 0, symbol: '' },

			assigned: [],
			assigned_origin: [],
			close_selection: 0,

			account_director: null,
			account_director_items: [],

			days: 0,
			is_daysApply: false,
			workdays: Workdays,
			workdays_keys: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
			workdays_keys_original: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],

			date_start: null,
			date_end: null,
			time_start: null,
			time_end: null,
			time_start_init: '',
			time_end_init: '',

			date_start_init: null,
			date_end_init: null,
			isSuggestedStart: false,
			isSuggestedEnd: false,
			date_range: [],

			item_params: {
				select_kinds: false,
				select_items: true,
				overhead_mode: 0,
			},
			items: [],
			currencies: [],

			isAllday: true,
			isActive: false,
			isShowTree: false,

			link_visible: false,
			link_url: '',

			delete_visible: false,

			visible_notice: false,
			notice_text: [],
			tid: null,

			status_completed_type: config.status_completed_type,
			task_id: 0,
			auto_time: 0,
			isHover: false,
			time_text: '',
			isRename: false,

			start_time_error: false,
			end_time_error: false,

			rules: [
				value => {
					return validHour(value);
				}
			],
			
			kind_selected: null,
			kindParams: {
				select_kinds: true,
				select_items: false,
				timesheet_kinds: true,
				overhead_mode: 0,
				traffic_only: true
			},
		}
	},
	components: {
		Share,
		Copy,
		SubTask,
		Delete,
		FindTimesheet,
		BudgetUsed,
		ProgressLinear,
		TaskLinkDialog,
		DialogNotice,
		KindTreeSelection,
		AssignedTreeSelection,
		DateMulti,
		LogTimesheet,
		DeleteConfirmDialog,
		DateTime
	},
	created() {
		const id = this.task ? this.task.id : this.$route.params.id;
		this.loadTask(id);
		this.$store.commit("push_breadcrumb", {
			exact: true,
			text: 'Task ' + id,
			to: `/task/${id}`
		});

		this.load_meta_data();
		this.getCurrencies();
		this.initSetupTime();
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	computed: {
		isRecording() {
			let isRecording = false;
			const recording_id = this.$store.state.recording.task_id;

			if (this.task_local && recording_id === this.task_local.id && this.task_local.status.type === ACTIVE_STATUS) {
				isRecording = true;
			}

			return isRecording;
		},
		recordingTaskId() {
			return this.$store.state.recording.task_id;
		},
		budget() {
			if (this.task_local == null) {
				return 'none';
			} else if (this.task_local.budget == 0) {
				return 'none';				
			} else {
				return this.format_duration(this.task_local.budget);
			}
		},
		actual() {
			if (this.task_local == null) {
				return 'none';
			} else if (this.task_local.actual == 0) {
				return 'none';				
			} else {
				return this.format_duration(this.task_local.actual);
			}
		},
		budget_used() {
			if (this.task_local == null) {
				return 0;
			} else {
				return this.task_local.budget_used;
			}
		},
		completedPhasePrivilege() {
			let isCompletedPhasesTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TPc)) {
				isCompletedPhasesTmp = true;
			}
			return isCompletedPhasesTmp
		},
		ratesPrivilege() {
			let isRatesTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TSr)) {
				isRatesTmp = true;
			}
			return isRatesTmp;
		},
		dateTimePrivilege() {
			let isDateTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TrSc)) {
				isDateTmp = true;
			}
			return isDateTmp;
		},
		otherEditPrivilege() {
			let isOtherEditTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TR)) {
				isOtherEditTmp = true;
			}
			return isOtherEditTmp;
		},
		descPrivilege() {
			let isDescTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TrN)) {
				isDescTmp = true;
			}
			return isDescTmp;
		},
		assignPrivilege() {
			let isAssignTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TrA)) {
				isAssignTmp = true;
			}
			return isAssignTmp;
		},
		itemsEnabledPrivilege() {
			let itemsEnabledTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(CH)) {
				itemsEnabledTmp = true;
			}
			return itemsEnabledTmp
		},
		completedJobPrivilege() {
			let isCompletedJobTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(JOr)) {
				isCompletedJobTmp = true;
			}
			return isCompletedJobTmp;
		},
		outsideBoundsPrivilege() {
			let isOutsideBoundsTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TrScO)) {
				isOutsideBoundsTmp = true;
			}
			return isOutsideBoundsTmp;
		},
		isCompleted() {
			let completedTmp = false;
			if (this.task && this.task.status && this.task.status.type === this.status_completed_type) {
				completedTmp = true;
			}
			return completedTmp;
		},
		showBudget() {
			let showBudget_tmp = true;

			if (this.budget_type === 2) {
				showBudget_tmp = this.ratesPrivilege;
			}

			return showBudget_tmp;
		},
		isFromOmins() {
			let is_from_omins = false;

			if (this.$route.params && this.$route.params.evid) {
				is_from_omins = true;
			}
			return is_from_omins;
		},
	},
	watch: {
		assigned() {
			this.isActive = this._isActive();
		},
		unit() {
			this.isActive = this._isActive();
		},
		amount() {
			this.isActive = this._isActive();
		},
		budget_enter() {
			this.isActive = this._isActive();

			const time_start = this.time_start ? this.time_start : '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			if (this.budget_enter.length !== 0 && validTime(time_start_tmp)) {
				const mins = budgetToMinutes(this.budget_enter);
				const start = moment(time_start_tmp, 'h:mma');
				const end = start.add(mins, 'minutes').format('h:mm a');
				this.time_end = end;			
			}
		},
		date_start() {			
			if (this.date_start !== this.date_start_init) {
				this.isSuggestedStart = false;
			} else {
				this.isSuggestedStart = true;
			}

			if (this.date_start && this.date_start.length !== 0 && this.date_start <= this.date_end) {
				const workdays_available = [];
				this.workdays.forEach(workday => {
					if (workday.isWork) {
						workdays_available.push(workday.key.toLocaleLowerCase())
					}
				});
				const workdays_keys_available = this.workdays_keys.filter(day => { return workdays_available.includes(day)})


				const start_moment = moment(this.date_start);
				const end_moment = moment(this.date_end);
				const days = end_moment.diff(start_moment, 'days');

				const date_arr = [];
				for (let index = 0; index < days + 1; index++) {
					const date = moment(this.date_start).add(index, 'days').format('YYYY-MM-DD');
					const week_str = moment(date).format('dddd');
					if (workdays_keys_available.includes(week_str.toLocaleLowerCase())) {
						date_arr.push(week_str);
					}
				}

				this.days = this.isSuggestedStart ? this.days : date_arr.length;
			}
				
			this.isActive = this._isActive();
		},
		date_end() {		
			if (this.date_end !== this.date_end_init && this.isSuggestedEnd) {
				this.isSuggestedEnd = false;
			}
			if (this.date_end === this.date_end_init && this.isSuggestedEnd) {
				this.isSuggestedEnd = true;
			}

			if (this.date_end && this.date_end.length !== 0 && this.date_start <= this.date_end) {
				const workdays_available = [];
				this.workdays.forEach(workday => {
					if (workday.isWork) {
						workdays_available.push(workday.key.toLocaleLowerCase())
					}
				});
				const workdays_keys_available = this.workdays_keys.filter(day => { return workdays_available.includes(day)})

				const start_moment = moment(this.date_start);
				const end_moment = moment(this.date_end);
				const days = end_moment.diff(start_moment, 'days');
				
				const date_arr = [];
				for (let index = 0; index < days + 1; index++) {
					const date = moment(this.date_start).add(index, 'days').format('YYYY-MM-DD');
					const week_str = moment(date).format('dddd');
				
					if (workdays_keys_available.includes(week_str.toLocaleLowerCase())) {
						date_arr.push(week_str);
					}
				}

				this.days = this.isSuggestedEnd ? this.days : date_arr.length;
			}

			this.isActive = this._isActive();
		},
		isHover() {
			if (this.isHover) {
				this.getTimeText();
			}
		}
	},
	methods: {
		async loadTask(task_id) {
			this.loading = true;
			const url = `/api/tasks/${task_id}?comments=true&worked_on=true`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason} = val.data;

					if (status == "OK") {
						this._setLocalTask(data);
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
					this.loading = false;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async initSetupTime() {
			this.loading = true;

			let url = '/api/config/setup/time';
			await axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						for (const [key, value] of Object.entries(data)) {
							if (key.startsWith('s')) {
								if (value.length !== 0) {
									const week_key = key.split('_');
									this.workdays_keys.push(week_key[1]);
									this.workdays_keys_original.push(week_key[1]);
								}
							}
						}
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getCurrencies() {
			const url = '/api/expenses/receipts/meta';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.currencies = data.currencies;
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		async getChargerate(params){
			let url = '/api/config/rates/chargerate';
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.charge_rate_total += data;
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		getPhases(job_id) {
			const url = '/api/jobs/' + job_id + '/phases';
			axios.get(url, {
				headers: {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"
				}
			})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						data.forEach(d => {
							if (this.isDuplication) {
								d['disabled'] = d.status === Completed_Phase ? true : false;
							} else {
								d['disabled'] = false;
							}
						});
						this.phaseItems = data;
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}

				})
				.catch(msg => {
					this.error_msg = this._errorMessageFormat(msg);
				})
		},
		getStatuses() {
			const statuses_tmp = JSON.parse(JSON.stringify(this.meta.statusses));
			statuses_tmp.forEach(s => {
				if (this.isRecording && s.type === this.status_completed_type) {
					s['disable'] = true;
				} else {
					s['disable'] = false;
				}
			});
			return statuses_tmp;
		},
		async onCreate() {
			let params_obj = null;
			await this._buildParams().then(val => {
				params_obj = val;
			});

			const url = "/api/tasks";
			axios
				.post(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						if (this.items.length === 0) {
							this.notice_text.push('Task has been created successfully');
							this.visible_notice = true;
							this.tid = setTimeout(this._close, 2000);
							this.$emit('task-close');
						} else {
							this.onCreateItems();
						}

					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		onCreateItems() {
			const params_arr = [];
			for (let index = 0; index < this.items.length; index++) {
				const element = this.items[index];

				const params = {};
				params['date'] = this.days > 1 ? moment().format('YYYYMMDD') : moment(this.date_start).format('YYYYMMDD');
				params['units'] = element.units;
				params['phase_id'] = this.task_phase.id;
				params['kind_id'] = element.kind.id;
				params['currency_id'] = element.currency.id;
				params['item_value'] = element.charge_rate * element.units;

				params_arr.push(params);
			}

			const url = params_arr.length === 1 ? '/api/items' : '/api/items/multipleitems';
			const params_req = params_arr.length === 1 ? params_arr[0] : { items : params_arr };

			axios
				.post(url, params_req, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, reason } = json;

					if (status == "OK") {
						this.notice_text.push('Task has been created successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						if (this.task) {
							this.$emit('task-close');
						} else {
							this.$router.push({ name: 'Dashboard' });
						}
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		formatDate(value) {
			if(!value) return null;
			return moment(value).format('DD MMM YYYY');
		},
		formatName(name) {
			let display_name = '';
			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		disableAutotimer(task, job) {
			let is_able = false;
			if (task && task.status && task.status.type === this.status_completed_type) {
				is_able = true;
			}

			if (this.completedJobPrivilege && job && job.job_status && !config.job_status_group_nomal.includes(job.job_status.status)) {
				is_able = true;
			}
			
			return is_able;
		},
		onAutotimer() {
			if (this.task_local.status.type !== ACTIVE_STATUS) return;

			if (this.isRecording) {
				const new_time = new Date().getTime();
				const time_passed_in_ms = new_time - this.$store.state.recording.started;
				const time_passed_in_mins = Math.round(time_passed_in_ms / 60000.0);
				const total_time = time_passed_in_mins;
				if (total_time === 0) {
					this.$store.dispatch('stop_recording');
				} else {
					this.auto_time = total_time;
				}
			} else {
				if (this.recordingTaskId === 0) {
					this.$store.dispatch('start_recording', { task_id: this.task_local.id, started: new Date().getTime() })
				} else {
					this.notice_text.push('Stop the auto time first, please');
					this.visible_notice = true;
					this.tid = setTimeout(this._close, 2000);
				}
			}
		},
		onFindTimesheet() {
			this.$emit('find-ts', this.task.id);
			this.$emit('task-close');
		},
		onCopyTask() {
			this.$emit('task-copy', this.task);
		},
		onSubTask() {
			this.$emit('task-sub', this.task);
		},
		onLink() {
			this.link_url = `${window.location.origin}/task/${this.task_local.id}`;
			this.link_visible = true;
		},
		onCopyLink(isSuccessful) {
			const text = isSuccessful ? 'Link copied successfully.':'Link copied failed.';
			this.notice_text.push(text);
			this.visible_notice = true;
			this.tid = setTimeout(this._close, 2000);

			this.link_visible = false;
		},
		onDeleteTask() {
			if (!this.otherEditPrivilege) return;

			this.delete_visible = true;
		},
		onDelete() {
			const url = `/api/tasks/${this.task.id}`;

			axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, reason} = val.data;

					if (status == "OK") {
						this.delete_visible = false;
						const title = this.task.title;

						this.notice_text.push(`Task ‘(${title})’ has been deleted successfully.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						this.$emit('task-close');
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch(e => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		onNameChange() {
			this.task_name = this.task_name === null ? '':this.task_name;
			this.isRename = false;
			this.isActive = this._isActive();

			if (!this.isDuplication && this.descPrivilege) {
				const params = [];
				params.push("description=" + this.task_name);

				this._updateOthers(params, 'set_description');
			}
		},
		async onKindChange(kind_value) {
			if (kind_value === null) {
				this.task_kind = null;
			} else {
				this.task_kind = kind_value;

				if (kind_value.budget_type === 2) {
					const budget = budgetToMinutes(this.budget_enter);
					if (budget !== 0) {
						this.getAmount();
					}
				}

				if (kind_value.def_role && kind_value.def_role.id) {
					const obj = {
						id: `${ROLES}_${kind_value.def_role.id}`,
						name: kind_value.def_role.name,
						type: ROLES,
						kind: true,
						tooltip: 'Role'
					};
					const existed_arr = this.assigned.filter(a => { return a.id === obj.id });
					if (existed_arr.length === 0) {
						this.assigned.push(obj);
					}
					this.onAssignChange(this.assigned);
				} else {
					if (kind_value.def_department && kind_value.def_department.id) {
						const obj = {
							id: `${DEPARTMENTS}_${kind_value.def_department.id}`,
							name: kind_value.def_department.name,
							type: DEPARTMENTS,
							kind: true,
							tooltip: 'Department'
						};
						const existed_arr = this.assigned.filter(a => { return a.id === obj.id });
						if (existed_arr.length === 0) {
							this.assigned.push(obj);
						}
						this.onAssignChange(this.assigned);
					}
				}
			}
			this.budget_type = kind_value ? kind_value.budget_type : 0;
			this.unit_type = kind_value ? kind_value.unit_type : null;

			if (this.unit_type) {
				const unit = Number.parseFloat(this.unit).toFixed(this.unit_type.decimals);
				this.unit = unit;
			}

			this.isActive = this._isActive();

			if (kind_value && !this.isDuplication && this.isActive && this.otherEditPrivilege) {
				this._updateTask();
			}
		},
		onAmountChange(amount_value) {
			this.amount = Number(amount_value);
			if (this.budget_type === 2) {
				this.getBudget();
			} else {
				this.isActive = this._isActive();

				if (!this.isDuplication && this.isActive && this.otherEditPrivilege) {
					this._updateTask();
				}
			}
		},
		async onBudget() {
			this.start_time_error = false;
			this.end_time_error = false;

			const time_start = this.time_start ? this.time_start : '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			if (this.budget_enter.length !== 0 && validTime(time_start_tmp)) {
				const mins = budgetToMinutes(this.budget_enter);

				const start = moment(time_start_tmp, 'HH:mma');
				const end = start.add(mins, 'minutes').format('h:mm a');
				this.time_end = end;			
			}

			if (this.budget_type === 2) {
				let result = this.budget_enter;
				if (NUMERICAL_REG.test(this.budget_enter)) {
					result = Number(this.budget_enter);
					result = `${result}h`;
				}

				const mins = budgetToMinutes(result);
				this.budget_enter = minutesToBudget(mins);

				await this.getAmount();
			}

			this.isActive = this._isActive();

			if (!this.isDuplication && this.isActive && this.otherEditPrivilege) {
				this._updateTask();
			}
		},
		async getAmount() {
			const params_arr = this._getChargeRateParams();

			if (params_arr.length === 0) {
				this.charge_rate_total = 0;

				await this.getChargerate(params_arr[0]);

				const units = budgetToMinutes(this.budget_enter);
				const amount = (units / 60) * this.charge_rate_total;
				this.amount =  Number.parseFloat(amount.toFixed(2));

			} else {
				this.charge_rate_total = 0;

				for (let index = 0; index < params_arr.length; index++) {
					await this.getChargerate(params_arr[index]);
				}

				const units = budgetToMinutes(this.budget_enter);
				const amount = (units / 60) * (this.charge_rate_total / params_arr.length);
				this.amount = Number.parseFloat(amount.toFixed(2));
			}
		},
		async getBudget() {
			const params_arr = this._getChargeRateParams();

			if (params_arr.length === 0) {
				this.charge_rate_total = 0;

				await this.getChargerate(params_arr[0]);

				const units = (this.amount / this.charge_rate_total) * 60;
				const units_int =  Number.parseInt(units.toFixed());
				this.budget_enter = minutesToBudget(units_int);
				
			} else {
				this.charge_rate_total = 0;

				for (let index = 0; index < params_arr.length; index++) {
					await this.getChargerate(params_arr[index]);
				}
				const charge_rate_average = this.charge_rate_total / params_arr.length;
				if (charge_rate_average !== 0) {
					const units = (this.amount / charge_rate_average) * 60;
					const units_int =  Number.parseInt(units.toFixed());
					this.budget_enter = minutesToBudget(units_int);
				}
			}
			
			this.isActive = this._isActive();

			if (!this.isDuplication && this.isActive && this.otherEditPrivilege) {
				this._updateTask();
			}
		},
		onStatusChange(status) {
			this.isActive = this._isActive();

			if (!this.isDuplication) {
				const params = [];
				params.push("status_id=" + status.id);

				this._updateOthers(params, 'set_status');
			}
		},
		onPriorityChange(priority) {
			this.isActive = this._isActive();

			if (!this.isDuplication) {
				const params = [];
				params.push("priority=" + (priority - 1));

				this._updateOthers(params, 'set_priority');
			}
		},
		onAcOcChange(acoc) {
			this.isActive = this._isActive();

			if (!this.isDuplication) {
				const params = [];
				
				const task_acoc = acoc !== AC_Type && acoc !== OC_Type ? 0 : acoc;
				params.push("acoc=" + task_acoc);

				this._updateOthers(params, 'set_acoc');
			}
		},
		onAssignChange(event) {
			const assigned_original = this.assigned;
			const is_remove = assigned_original.length > event.length ? true : false;
			this.assigned = event;
			
			/** leave it, keep the same behavior as job planning */
			/**
				if (this.budget_type === 2) {
					this.getAmount();
				}
			*/

			if (!this.isDuplication && assigned_original.length !== event.length) {
				const event_ids = event.map(a => { return a.id});
				const filter_events = is_remove ? assigned_original.filter(e => { return !event_ids.includes(e.id)}) : event;

				let url = `/api/tasks/${this.task_local.id}/${is_remove ? 'remove_taskfor':'set_taskfor'}`;

				const task_for_arr = [];

				filter_events.forEach(e => {
					const assigned_id_split = e.id.split('_');

					const assigned_obj = {};
					const mode = Number(assigned_id_split[0]) === FREELANCER ? ALLEMPLOYEES : assigned_id_split[0];
					assigned_obj['mode'] = Number(mode);

					if (Number(mode) === DEPARTMENTS) {
						assigned_obj['department_id'] = Number(assigned_id_split[1]);
					}

					if (Number(mode) === ROLES) {
						assigned_obj['role_id'] = Number(assigned_id_split[1]);
					}

					if (Number(mode) === ALLEMPLOYEES) {
						assigned_obj['employee_id'] = Number(assigned_id_split[1]);
					}

					task_for_arr.push(assigned_obj);
				});

				const params_obj = {
					is_for: task_for_arr
				};

				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, reason } = json;

						if (status == "OK") {
							const {status, data, reason} = val.data;

							if (status == "OK") {
								this._setLocalTask(data);
							} else {
								this.error_msg = this._errorMessageFormat(reason);
							}
						} else {
							this.error_msg = this._errorMessageFormat(reason);
						}
					})
					.catch((e) => {
						this.error_msg = this._errorMessageFormat(e.message);
					});
			}
		},
		onUnits(value) {
			if (value.length === 0) return;

			if (this.unit_type.decimals === 0) {
				this.unit = Math.ceil(value);
			} else {
				this.unit = Number.parseFloat(value).toFixed(this.unit_type.decimals);
			}
		},
		onAlldayChange(all_day) {
			this.isActive = this._isActive();

			const need_clear_time = all_day && this.time_start && this.time_start.length && this.time_end && this.time_end.length;
			if (!this.isDuplication && this.dateTimePrivilege && need_clear_time) {
				const params = [];
				params.push("start_date=" + this.date_start);
				params.push("end_date=" + this.date_end);

				this._updateDate(params);
			}
		},
		onDateChange(date_arr) {
			this.error_msg = '';

			if (date_arr.length === 0) {
				this.date_start = '';
				this.date_end = '';
			}

			if (date_arr.length === 2) {
				let is_save_able = !(this.date_start === date_arr[0] && this.date_end === date_arr[1]);

				this.date_start = date_arr[0];
				this.date_end = date_arr[1];

				if (!this.isDuplication && this.dateTimePrivilege && is_save_able) {
					const params = [];
					params.push("start_date=" + this.date_start);
					params.push("end_date=" + this.date_end);

					this._updateDate(params);
				}
			}

			this.isActive = this._isActive();
		},
		onTimeStartChange(time) {
			this.start_time_error = false;
			this.end_time_error = false;

			this.time_start = time;

			this.onStartTime();
		},
		onTimeEndChange(time) {
			this.start_time_error = false;
			this.end_time_error = false;

			this.time_end = time;

			this.onEndTime();
		},
		onStartTime() {
			const time_start = this.time_start ? this.time_start : '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			const time_end = this.time_end ? this.time_end : '0';
			let time_end_tmp = time_end.replace(/\s+/g,"");

			if (this.budget_type === 2) {
				if (validTime(time_start_tmp) && validTime(time_end_tmp)) {
					const time1 = moment(time_start_tmp, 'HH:mma');
					const time2 = moment(time_end_tmp, 'HH:mma');
					const budget = time2.diff(time1, 'minutes');

					if (budget < 0) {
						this.start_time_error = true;
					} else {
						this.budget_enter = minutesToBudget(budget);
					}

					this.getAmount();
				}
			}

			this.isActive = this._isActive();

			let duration = 0;
			if (this.time_start && this.time_end && this.time_start.length !== 0 && this.time_end.length !== 0) {
				const time1 = moment(this.time_start, 'h:mm a');
				const time2 = moment(this.time_end, 'h:mm a');
				duration = time2.diff(time1, 'minutes');
			}

			if (!this.isDuplication && this.dateTimePrivilege && duration > 0) {
				const params = [];

				const start_date = moment(`${this.date_start} ${this.time_start}`, 'YYYY-MM-DD h:mm a').format('YYYY-MM-DD HH:mm:ss') ;
				params.push(`start_date=${start_date}`);

				const end_date = moment(`${this.date_end} ${this.time_end}`, 'YYYY-MM-DD h:mm a').format('YYYY-MM-DD HH:mm:ss');
				params.push(`end_date=${end_date}`);

				this._updateDatetime(params);
			}
		},
		onEndTime() {
			const time_start = this.time_start ? this.time_start : '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			const time_end = this.time_end ? this.time_end : '0';
			let time_end_tmp = time_end.replace(/\s+/g,"");

			if (this.budget_type === 2) {
				if (validTime(time_start_tmp) && validTime(time_end_tmp)) {
					const time1 = moment(time_start_tmp, 'HH:mma');
					const time2 = moment(time_end_tmp, 'HH:mma');
					const budget = time2.diff(time1, 'minutes');

					if (budget < 0) {
						this.end_time_error = true;
					} else {
						this.budget_enter = minutesToBudget(budget);
					}

					this.getAmount();
				}
			}			

			this.isActive = this._isActive();

			let duration = 0;
			if (this.time_start && this.time_end && this.time_start.length !== 0 && this.time_end.length !== 0) {
				const time1 = moment(this.time_start, 'h:mm a');
				const time2 = moment(this.time_end, 'h:mm a');
				duration = time2.diff(time1, 'minutes');
			}

			if (!this.isDuplication && this.dateTimePrivilege && duration > 0) {
				const params = [];

				const start_date = moment(`${this.date_start} ${this.time_start}`, 'YYYY-MM-DD h:mm a').format('YYYY-MM-DD HH:mm:ss') ;
				params.push(`start_date=${start_date}`);

				const end_date = moment(`${this.date_end} ${this.time_end}`, 'YYYY-MM-DD h:mm a').format('YYYY-MM-DD HH:mm:ss');
				params.push(`end_date=${end_date}`);

				this._updateDatetime(params);
			}
		},
		onWorkday(workday) {
			if (!this.dateTimePrivilege) return;

			workday.isWork = !workday.isWork; 

			const workdays_available = [];
			this.workdays.forEach(workday => {
				if (workday.isWork) {
					workdays_available.push(workday.key.toLocaleLowerCase())
				}
			});
			const workdays_keys_available = this.workdays_keys_original.filter(day => { return workdays_available.includes(day)})
			this.workdays_keys = workdays_keys_available;
			
			this.isActive = this._isActive();

			if (!this.isDuplication) {
				const params = [];
				const workdays = (this.workdays.map(w => { return w.isWork ? 1:0})).join('');
				params.push("day_flags=" + workdays);
			
				this._updateOthers(params, 'set_dayflags');
			}
		},
		getToday() {
			return moment().format('YYYY-MM-DD');
		},
		onItemsChange(items) {
			this.items = items;
			this.isActive = this._isActive();
		},
		onCloseTimesheet() {
			const id = this.task ? this.task.id : this.$route.params.id;
			this.loadTask(id);
		
			this.task_id = 0;
		},
		getTimeText() {
			const new_time = new Date().getTime();
			const time_passed_in_ms = new_time - this.$store.state.recording.started;
			const time_passed_in_mins = Math.round(time_passed_in_ms / 60000.0);

			const hours_passed = Math.floor(time_passed_in_mins / 60.0);
			const minutes_passed = time_passed_in_mins - (hours_passed * 60);

			this.time_text = `${hours_passed}h ${minutes_passed}m`;
		},
		_isActive() {
			let isActive = false;

			if (this.isDuplication) {			
				if (this.task_name.length !== 0 && this.task_phase && this.task_status && this.priority !== 0) {
					isActive = true;
				}
			} else {
				if (this.task_name.length !== 0 && this.task_phase && this.task_status && this.priority !== 0) {
					if (this.task_name !== this.task_local.title) {
						isActive = true;
					}
					if (this.task_phase.id !== this.task_local.phase.id) {
						isActive = true;
					}
					if (this.task_status.id !== this.task_local.status.id) {
						isActive = true;
					}
					if (this.priority !==  this.task_local.priority + 1) {
						isActive = true;
					}

					if (this.budget_type !== this.task_local.budget_type) {
						isActive = true;
					} else {
						if (this.budget_type === 1) {
							if (this.amount !== 0 &&  Number(this.amount) !== Number(this.task_local.value)) {
								isActive = true;
							}
						}
						if (this.budget_type === 2) {
							if (this.budget_enter.length !== 0 && this.budget_enter !== minutesToBudget(this.task_local.budget)) {
								isActive = true;
							}
						}
					}

					if (Number(this.amount) !== Number(this.task_local.value)) {
						isActive = true;
					}

					const date_start_tmp = this.task_local.start_date ? moment(this.task_local.start_date, 'Do MMM YYYY').format('YYYY-MM-DD') : '';
					const date_end_tmp = this.task_local.end_date ?moment(this.task_local.end_date, 'Do MMM YYYY').format('YYYY-MM-DD') : '';

					if (this.date_start && this.date_start !== date_start_tmp && this.date_start <= this.date_end) {
						isActive = true;
					}
					if (this.date_end && this.date_end !== date_end_tmp && this.date_start <= this.date_end) {
						isActive = true;
					}
					if (!this.date_start && !this.date_end && this.date_start !== date_start_tmp && this.date_end !== date_end_tmp) {
						isActive = true;
					}

					if (this.task_local.has_time === this.isAllday) {
						if (this.isAllday) {
							isActive = true;
						} 
					
						if (!this.isAllday && this.time_end && this.time_end.length !== 0 && this.time_start && this.time_start.length !== 0) {
							const start_time_tmp = moment(this.time_start, 'h:mm a').format('HH:mm');
							const end_time_tmp = moment(this.time_end, 'h:mm a').format('HH:mm');
							if (start_time_tmp < end_time_tmp) {
								isActive = true;
							}
						}
					}

					const time_start_tmp = this.task_local.has_time ? moment(this.task_local.start_time, 'HH:mma').format('HH:mm') : null;
					if (!this.isAllday && this.time_start && this.time_start.length !== 0 && this.time_start !== time_start_tmp && this.time_end && this.time_end.length !== 0) {
						const start_time_tmp = moment(this.time_start, 'h:mm a').format('HH:mm');
						const end_time_tmp = moment(this.time_end, 'h:mm a').format('HH:mm');
						if (start_time_tmp < end_time_tmp) {
							isActive = true;
						}
					}
					const time_end_tmp = this.task_local.has_time ? moment(this.task_local.end_time, 'HH:mma').format('HH:mm') : null;
					if (!this.isAllday && this.time_end && this.time_end.length !== 0 && this.time_end !== time_end_tmp && this.time_start && this.time_start.length !== 0) {
						const start_time_tmp = moment(this.time_start, 'h:mm a').format('HH:mm');
						const end_time_tmp = moment(this.time_end, 'h:mm a').format('HH:mm');

						if (start_time_tmp < end_time_tmp) {
							isActive = true;
						}
					}

					if (this.task_local && this.task_local.For && this.assigned.length !== this.task_local.For.length) {
						isActive = true;
					} else {
						if (this.assigned.length !== 0) {
							const assigned_current = this.assigned.map(a => { return a.id});
							assigned_current.sort((a,b) => { return b-a});

							const assigned_origin = this.assigned_origin.map(a => { return a.id});
							assigned_origin.sort((a,b) => { return b-a});

							if (JSON.stringify(assigned_current) !== JSON.stringify(assigned_origin)) {
								isActive = true;
							}
						}
					}

					const workday_str = (this.workdays.map(w => { return w.isWork ? 1:0})).join('');
					if (this.task_local.workdays !== workday_str) {
						isActive = true;
					}
				}
			}

			return isActive;
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
		},
		_buildAssigned(array) {
			const result_arr = [];
			array.forEach(a => {
				const obj = {};
				if (a.Type === ALLEMPLOYEES) {
					obj['id'] = `${a.is_freelancer && !a.is_employee ? FREELANCER : ALLEMPLOYEES}_${a.AbookId}`,
					obj['type'] = a.is_freelancer && !a.is_employee ? FREELANCER : a.Type,
					obj['name'] = this.formatName(a.DisplayName)
				}
				if (a.Type === ROLES) {
					obj['id'] = `${ROLES}_${a.RoleId}`,
					obj['type'] = a.Type,
					obj['name'] = this.formatName(a.DisplayName)
				}
				if (a.Type === DEPARTMENTS) {
					obj['id'] = `${DEPARTMENTS}_${a.DepartmentId}`,
					obj['type'] = a.Type,
					obj['name'] = this.formatName(a.DisplayName)
				}
				result_arr.push(obj);
			});
			
			return result_arr;
		},
		_initTaskParams() {
			const params_obj = {};

			params_obj['id'] = this.task_local.id;
			params_obj['description'] = this.task_local.description;
			params_obj['parent_id'] = this.task_local.parent_id;
			params_obj['text_color'] = this.task_local.text_color;
			params_obj['phase_id'] = this.task_local.phase_id;
			params_obj['kind_id'] = this.task_local.kind_id;
			params_obj['status_id'] = this.task_local.status_id;
			params_obj['priority'] = this.task_local.priority;
			params_obj['acoc'] = this.task_local.acoc;
			params_obj['on_planning'] = this.task_local.on_planning;
			params_obj['on_timeline'] = this.task_local.on_timeline;
			params_obj['has_time'] = this.task_local.has_time;
			params_obj['is_suggested'] = this.task_local.is_suggested;
			params_obj['start'] = this.task_local.start;
			params_obj['end'] = this.task_local.end;
			params_obj['days'] = this.task_local.days;
			params_obj['workdays'] = this.task_local.workdays;
			params_obj['assigned'] = this.task_local.assigned;

			return params_obj;
		},
		async _buildParams() {
			const params_obj = this._initTaskParams();

			// assigned
			const assigned_tmp = [];
			if (this.assigned.length !== 0) {
				this.assigned.forEach(a => {
					const assigned_id = typeof(a.id) === 'string' ? a.id : a.id.toString();
					const assigned_id_split = assigned_id.split('_');

					if (assigned_id_split.length > 1) {
						const assigned_obj = {};
						const mode = Number(assigned_id_split[0]) === FREELANCER ? ALLEMPLOYEES : assigned_id_split[0];
						assigned_obj['mode'] = Number(mode);

						if (Number(mode) === DEPARTMENTS) {
							assigned_obj['department_id'] = Number(assigned_id_split[1]);
						}

						if (Number(mode) === ROLES) {
							assigned_obj['role_id'] = Number(assigned_id_split[1]);
						}

						if (Number(mode) === ALLEMPLOYEES) {
							assigned_obj['abook_id'] = Number(assigned_id_split[1]);
						}

						assigned_tmp.push(assigned_obj);
					}
				});
			}
			params_obj['assigned'] = assigned_tmp;
			
			// kind
			if (this.task_kind) {
				params_obj['kind_id'] = this.task_kind.id;
			}

			// budget_type
			const budget_type = this.budget_type;
			params_obj['budget_type'] = budget_type;

			if (budget_type === 0) {
				params_obj['units'] = 0;
				params_obj['charge_rate'] = 0;
				params_obj['value'] = 0;
			}

			if (budget_type === 1) {
				params_obj['value'] = Number(this.amount);
				params_obj['units'] = 0;
				params_obj['charge_rate'] = 0;
			}

			if (budget_type === 2) {
				const units = budgetToMinutes(this.budget_enter);
				params_obj['units'] = units;

				const params_arr = this._getChargeRateParams();

				if (params_arr.length === 0) {
					this.charge_rate_total = 0;
					await this.getChargerate(params_arr[0]);

					params_obj['charge_rate'] = this.charge_rate_total;
					const value = (units / 60) * this.charge_rate_total;
					params_obj['value'] = value; 

				} else {
					this.charge_rate_total = 0;

					for (let index = 0; index < params_arr.length; index++) {
						await this.getChargerate(params_arr[index]);
					}

					const charge_rate_average = this.charge_rate_total / assigned_tmp.length;
					params_obj['charge_rate'] = charge_rate_average;
					const value = (units / 60) * charge_rate_average;
					params_obj['value'] = value; 
				}
			}
			
			// days and date
			if (this.date_start && this.date_end && this.date_start <= this.date_end) {
				params_obj['days'] = this.days;
				params_obj['start'] = !this.time_start ? moment(new Date(this.date_start)).format('YYYYMMDD') : `${moment(this.date_start).format('YYYYMMDD')} ${moment(this.time_start, 'h:mm a').format('HH:mm')}`;
				params_obj['end'] = !this.time_end ? moment(new Date(this.date_end)).format('YYYYMMDD') : `${moment(this.date_start).format('YYYYMMDD')} ${moment(this.time_end, 'h:mm a').format('HH:mm')}`;
			} else {
				params_obj['days'] = 0;
			}

			params_obj['id'] = this.task_local.id;
			params_obj['description'] = this.task_name;
			params_obj['phase_id'] = this.task_local.phase.id;
			params_obj['priority'] = this.priority - 1;
			params_obj['has_time'] = this.time_start && this.time_end ? true : false;
			params_obj['status_id'] = this.task_status.id;
			params_obj['workdays'] = (this.workdays.map(w => { return w.isWork ? 1:0})).join('');
			params_obj['acoc'] = 0;
			params_obj['on_planning'] = true;
			params_obj['on_timeline'] = true;
			params_obj['is_suggested'] = this.date_start && this.date_end && this.date_start <= this.date_end ? false:true;
			params_obj['text_color'] = TEXT_COLOR;
			
			return params_obj;
		},
		_getChargeRateParams() {
			const params_arr = [];

			if (this.assigned.length === 0) {
				const params = [];
				if (this.task_job && this.task_job.id !== 0) {
					params.push('job_id=' + this.task_job.id);
					params.push('currency_id=' + this.currency.id);
				}
				if (this.task_kind && this.task_kind.id !== 0) {
					params.push('kind_id=' + this.task_kind.id);
				}

				params_arr.push(params);
				
			} else {
				for (let index = 0; index < this.assigned.length; index++) {
					const params = [];
					
					if (this.task_job && this.task_job.id !== 0) {
						params.push('job_id=' + this.task_job.id);
						params.push('currency_id=' + this.currency.id);
					}
					if (this.task_kind && this.task_kind.id !== 0) {
						params.push('kind_id=' + this.task_kind.id);
					}

					const element = this.assigned[index];
					if (Number(element.type) === ROLES) {
						const split_ids = element.id.split('_');
						params.push('role_id=' + split_ids[split_ids.length -1]);
					}
					if (Number(element.type) === ALLEMPLOYEES) {
						const split_ids = element.id.split('_');
						params.push('employee_id=' + split_ids[split_ids.length -1]);
					}

					params_arr.push(params);
				}
			}

			return params_arr;
		},
		_updateDate(params) {			
			let url = `/api/tasks/${this.task_local.id}/set_dates`;
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason} = val.data;

					if (status == "OK") {
						if (this.isDuplication) {
							if (this.items.length === 0) {
								this.notice_text.push('Task has been updated successfully');
								this.visible_notice = true;
								this.tid = setTimeout(this._close, 2000);

								if (this.task) {
									this.$emit('task-close');
								} else {
									this.$router.push({ name: 'Dashboard' });
								}
							} else {
								this.onCreateItems();
							}

						} else {
							this._setLocalTask(data);
						}
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		_updateDatetime(params) {
			let url = `/api/tasks/${this.task_local.id}/set_datetime`;
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason} = val.data;

					if (status == "OK") {
						if (this.isDuplication) {
							if (this.items.length === 0) {
								this.notice_text.push('Task has been updated successfully');
								this.visible_notice = true;
								this.tid = setTimeout(this._close, 2000);

								if (this.task) {
									this.$emit('task-close');
								} else {
									this.$router.push({ name: 'Dashboard' });
								}
							} else {
								this.onCreateItems();
							}
						} else {
							this._setLocalTask(data);
						}					
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		_updateOthers(params, url_key) {
			let url = `/api/tasks/${this.task_local.id}/${url_key}`;
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason} = val.data;

					if (status == "OK") {
						this._setLocalTask(data);
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		async _updateTask() {
			let params_obj = null;

			await this._buildParams().then(val => {
				params_obj = val;
			});

			const url = `/api/tasks/${this.task_local.id}`;

			axios
				.put(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					const { status, data, reason } = json;

					if (status == "OK") {
						this._setLocalTask(data);
					} else {
						this.error_msg = this._errorMessageFormat(reason);
					}
				})
				.catch((e) => {
					this.error_msg = this._errorMessageFormat(e.message);
				});
		},
		_setLocalTask(task) {
			if (task.workdays.length === 0) {
				task['workdays'] = Default_Workday;
			}
			this.task_local = task;
			this.task_local.acc_exec.name = task.acc_exec.name ? this.formatName(task.acc_exec.name) : '';

			this.task_name = task.title;
			this.task_phase = task.phase;
			this.task_status = task.status;

			const kind = task.kind && task.kind.id !== null ? JSON.parse(JSON.stringify(task.kind)) : null;
			if (kind) {
				kind['display_name'] = kind.name;
			}

			this.task_kind = kind;
			this.kind_selected = kind;
						
			if (task.job_type.is_overhead) {
				this.kindParams.overhead_mode = 2;
			} else {
				this.kindParams.overhead_mode = 1;
			}

			this.item_params.overhead_mode = task.job_type.is_overhead ? Overhead_Mode : Any_Mode;

			this.budget_type = task.budget_type;
			this.task_job = task.job;
			this.task_job['currency'] = task.currency;
			this.getPhases(this.task_job.id);
			this.currency = task.currency;
			this.assigned = task.For ? this._buildAssigned(task.For ) : [];
			this.assigned_origin = task.For ? this._buildAssigned(task.For ) : [];
			
			this.account_director = this.task_local.acc_exec;
			this.account_director_items = [this.task_local.acc_exec];
			this.priority = task.priority + 1;

			this.ac_oc = task.acoc !== AC_Type && task.acoc !== OC_Type ? null : task.acoc;

			this.workdays.forEach(( w, index )=> {
				w.isWork = Number(task.workdays[index]) === 1 ? true: false;
			});

			this.isAllday = !task.has_time;
			this.isSuggestedStart = task.is_suggested;
			this.isSuggestedEnd = task.is_suggested;
						
			this.date_start_init = task.start_date ? moment(task.start_date, 'Do MMM YYYY').format('YYYY-MM-DD') : '';
			this.date_end_init = task.end_date ? moment(task.end_date, 'Do MMM YYYY').format('YYYY-MM-DD') : '';
			this.date_start = task.start_date ? moment(task.start_date, 'Do MMM YYYY').format('YYYY-MM-DD') : '';
			this.date_end = task.end_date ? moment(task.end_date, 'Do MMM YYYY').format('YYYY-MM-DD') : '';

			this.time_start = task.has_time && task.start_datetime ? moment(new Date(task.start_datetime)).format('h:mm a') : null;
			this.time_end = task.has_time && task.end_datetime ? moment(new Date(task.end_datetime)).format('h:mm a') : null;

			this.time_start_init = this.time_start ? this.time_start : '';
			this.time_end_init = this.time_end ? this.time_end : '';

			this.amount = task.value;
			this.budget_enter = minutesToBudget(task.units);
			this.unit = task.units;

			if (!this.outsideBoundsPrivilege) {
				if (task.parent) {
					if (task.parent.start_date !== null && task.parent.end_date !== null) {
						const start_date = moment(task.parent.start_date).format('YYYY-MM-DD');
						const end_date = moment(task.parent.end_date).format('YYYY-MM-DD');
						this.date_range = [start_date, end_date];
					} else {
						if (task.phase.start_date !== null && task.phase.end_date !== null) {
							this.date_range = [task.phase.start_date, task.phase.end_date];
						} else {
							this.date_range = [];
						}
					}
				} else {
					if (task.phase.start_date !== null && task.phase.end_date !== null) {
						this.date_range = [task.phase.start_date, task.phase.end_date];
					} else {
						this.date_range = [];
					}
				}
			}
		},
		_errorMessageFormat(msg) {
			let msg_str = msg;

			if (msg_str.includes(Error_Flag)) {
				msg_str = (msg_str.split(Error_Flag))[1];
			}
			
			return msg_str;
		}
	}
}
</script>
<style lang="scss" scoped>
.task-detail {
  background: #FFFFFF;
  box-shadow: -5px 0px 5px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
	width: 100%;
}
.task-top-line {
  width: 100%;
  height: 4px;
  background: #81CC00;
  border-radius: 4px 4px 0 0;
}
.task-top {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
}
.task-top-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #81CC00;
}
.task-title {
	width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
}
.task-title-content {
	width: 100%;
  display: flex;
  flex-flow: column nowrap;
	justify-content: center;
  align-items: flex-start;
}
.task-title-text {
	font-family: Roboto;
	font-size: 20px;
	font-weight: 500;
	line-height: 32px;
	letter-spacing: -0.5px;
  color: rgba(25, 42, 62, 1)
}
.icon-text {
	font-family: Roboto;
	font-size: 16px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: rgba(96, 152, 0, 1);
}
.code-text {
	font-family: Roboto;
	font-size: 16px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.5px;
	color: rgba(25, 42, 62, 1);
}
.text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: rgba(25, 42, 62, 0.7);
}
.sub-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.4px;
  color: rgba(25, 42, 62, 0.7);
  margin-top: 1px;
}
.job-name-text {
	width: 100%;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
.task-budget {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.task-logged-text {
  font-family: Roboto;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0.25px;
  color: #192A3E;
}
.task-info-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
}
.task-info-text-disable {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #B9C2CB;
  opacity: 0.87;
}
.item-and-icon {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
}
.item-text-disable {
	color: #B9C2CB;
	opacity: 0.87;
}


.optional-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;

	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}
.optional-text-red {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;

	color: #F45252;
}
.task-icon-invisible {
  width: 20px;
  height: 20px;
  color: #81CC00;
}
.link-icon {
	&:hover {
		cursor: pointer;
	}
}
.edit-disable {
	cursor: not-allowed;
}

::v-deep {
	.v-treeview--dense .v-treeview-node__root {
		min-height: 32px;
	}
	.v-treeview-node__content {
		min-height: 32px;
	}
}

</style>